import React, { useEffect } from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import type { ChatDoc } from '../types/chat';
import { chatEditorExtensions } from '../utils/chatEditorExtensions';
import { EditorToolbar } from './EditorToolbar';

interface ChatDocEditorProps {
    id: string;
    ariaLabel: string;
    initialDoc: ChatDoc;
    disabled: boolean;
    onChange: (doc: ChatDoc) => void;
}

// A standalone editor on the composer's schema, for docs that are inserted into chats later.
const ChatDocEditor: React.FC<ChatDocEditorProps> = ({
    id,
    ariaLabel,
    initialDoc,
    disabled,
    onChange
}) => {
    const editor = useEditor({
        extensions: chatEditorExtensions(),
        content: initialDoc,
        onUpdate: ({ editor: current }) => onChange(current.getJSON()),
        editorProps: { attributes: { id, 'aria-label': ariaLabel, class: 'prose-chat' } }
    });

    useEffect(() => {
        editor?.setEditable(!disabled, false);
    }, [editor, disabled]);

    return (
        <div className="rounded-md border border-gray-300 shadow-sm focus-within:border-indigo-500">
            <div className="tiptap-editor [&_.ProseMirror]:min-h-[80px] [&_.ProseMirror]:max-h-[320px]">
                <EditorContent editor={editor} />
            </div>
            <div className="border-t border-gray-200 px-2">
                <EditorToolbar editor={editor} />
            </div>
        </div>
    );
};

export { ChatDocEditor };
